import { Components, Theme } from '@mui/material/styles';

export const MuiDialogActions: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(6),
      paddingInline: theme.spacing(4),

      // Need the empty as use-confirm render content even though it is empty
      '.MuiDialogTitle-root + &, .MuiDialogContent-root:empty + &': {
        paddingTop: theme.spacing(2),
      },
    }),
  },
};
